import Cookies from 'js-cookie';

import {
  LIST_TYPES,
  SET_LIST_TYPE,
} from './actions';

const initialState = {
  listType: Cookies.get('listType') ?? LIST_TYPES.GRID,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST_TYPE:
      Cookies.set('listType', action.payload);
      return {
        ...state,
        listType: action.payload,
      };
    default:
      return state;
  }
};
